import { TextField, MenuItem } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { useCreateNomenklaturaMutation } from "../../../store/nomenklaturaApi";
import { useGetCategoriesQuery } from "../../../store/coefficientsApi/categoryApi";
import { useGetK2Query } from "../../../store/coefficientsApi/k2Api";
import { useGetK1Query } from "../../../store/coefficientsApi/k1Api";
import { useGetK4Query } from "../../../store/coefficientsApi/k4Api";


export default function CreateNomenklatura({ onClose }) {
  const { data: categoryFB } = useGetCategoriesQuery();
  const { data: k1FB } = useGetK1Query();
  const { data: k2FB } = useGetK2Query();
  const {data: k4FB} = useGetK4Query()
  const [addNomenklatura] = useCreateNomenklaturaMutation();
  const [name, setName] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [inventNumber, setInventNumber] = React.useState("");
  const [addressNumber, setAddressNumber] = React.useState("");
  const [category, setCategory] = React.useState([]);
  const [categoryID, setCategoryID] = React.useState(99);
  const [square, setSquare] = React.useState("");
  const [k2, setK2] = React.useState([]);
  const [k2ID, setK2ID] = React.useState(99);
  const [coordinates, setCoordinates] = React.useState("");
  const [k1, setK1] = React.useState([]);
  const [k1ID, setK1ID] = React.useState(99);
  const [k4, setK4] = React.useState([]);
  const [k4ID, setK4ID] = React.useState(99);

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const categories = await categoryFB.data;
        const k2s = await k2FB.data;
        const k1s = await k1FB.data;
        const k4s = await k4FB.data;
        setCategory(categories);
        setK2(k2s);
        setK1(k1s);
        setK4(k4s)
      } catch (error) {}
    };
    setDataToStates();
  }, [categoryFB, k2FB, k1FB, k4FB]);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    addNomenklatura({
      name,
      address,
      inventNumber,
      addressNumber,
      square,
      k2: k2ID,
      k1: k1ID,
      k4: k4ID,
      coordinates,
      category: categoryID,
      type: 'object'
    });
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfContragent>Карточка объекта</TitleOfContragent>
      <BlockStyled
        margin="0 0 20px 0"
        width="100%"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Наименование"
          variant="outlined"
          value={name}
          onChange={(event) => inputChangeHandler(event, setName)}
          width="48%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Идентификационный код"
          variant="outlined"
          value={inventNumber}
          onChange={(event) => inputChangeHandler(event, setInventNumber)}
          width="30%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Площадь"
          variant="outlined"
          value={square}
          onChange={(event) => inputChangeHandler(event, setSquare)}
          width="20%"
        />
      </BlockStyled>
      <BlockStyled
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Адрес"
          variant="outlined"
          value={address}
          onChange={(event) => inputChangeHandler(event, setAddress)}
          width="40%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="№"
          variant="outlined"
          value={addressNumber}
          onChange={(event) => inputChangeHandler(event, setAddressNumber)}
          width="12%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Координаты"
          variant="outlined"
          value={coordinates}
          onChange={(event) => inputChangeHandler(event, setCoordinates)}
          width="45%"
        />
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0">
        <TextFieldStylded
          id="select"
          select
          label="Категория"
          variant="outlined"
          width="100%"
          value={categoryID}
        >
          {category.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setCategoryID(item.id)}
              >
                {item.attributes.name}
              </MenuItem>
            );
          })}
          <MenuItem value={99}> </MenuItem>
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="select"
          select
          label="Коэффициент коммерческого использования"
          variant="outlined"
          width="100%"
          value={k2ID}
        >
          {k2.map((item) => {
            return (
              <MenuItem
                key={item.id}
                onClick={() => setK2ID(item.id)}
                value={item.id}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
          <MenuItem value={99}> </MenuItem>
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0"> 
        <TextFieldStylded
          id="select"
          select
          label="Коэффициент определяемый от месторасположения участка"
          variant="outlined"
          width="100%"
          value={k1ID}
        >
          {k1.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setK1ID(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
          <MenuItem value={99}> </MenuItem>
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled margin="0 0 20px 0"> 
        <TextFieldStylded
          id="select"
          select
          label="Коффициент определяемый от общей площади предоставляемого земельного участка"
          variant="outlined"
          width="100%"
          value={k4ID}
        >
          {k4.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setK4ID(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
          <MenuItem value={99}> </MenuItem>
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled display="flex" justifyContent="flex-end">
      <BasicButtons>
            <a
              rel="noreferrer"
              target="_blank"
              href={coordinates ? `https://maps.google.com?Location&daddr=${coordinates}` : "https://maps.google.com"}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              на карте
            </a>
          </BasicButtons>
        <BasicButtons onClick={onClose}>Отменить</BasicButtons>
        <BasicButtons type="submit">Сохранить</BasicButtons>
      </BlockStyled>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const TitleOfContragent = styled.h3`
  text-align: center;
`;
// =========================== Блок кнопок ======================================\\
const StyledForm = styled.form``;
